export const InputDescription = (props: { children: string; id: string }) => {
  return (
    <p className="text-medium-hippo text-base" id={props.id}>
      {props.children}
    </p>
  );
};
